import { render, staticRenderFns } from "./rtc.vue?vue&type=template&id=70d0eaaf&scoped=true&"
import script from "./rtc.vue?vue&type=script&lang=js&"
export * from "./rtc.vue?vue&type=script&lang=js&"
import style0 from "./rtc.vue?vue&type=style&index=0&id=70d0eaaf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d0eaaf",
  null
  
)

export default component.exports